export default __webpack_public_path__ + "static/media/email-svg-ic.7f1a3816.svg";